export class PageLoadedEvent {
  event = 'page loaded' as const;
}